import { GROUPED_PRIVILEGES } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { RecentEventsPage } from '@/pages/reporting/recent-events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/reporting/recent-events')({
  beforeLoad: () => {
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.viewReporting });
  },
  component: RecentEventsPage,
});
